import React, { useState } from "react";
import { userData } from "../modules/AuthenticationProvider";

const UserSettingsContext = React.createContext(null);

function UserSettingsProvider({ children }) {
  let logedUserData = userData();
  let [currentUser, setCurrentUser] = useState(logedUserData);

  return (
    <UserSettingsContext.Provider
      value={{
        currentUser: currentUser,
        setCurrentUser: (newCurrent) => setCurrentUser({ ...currentUser, ...newCurrent }),
        setContexto: (contexto) => setCurrentUser({ ...currentUser, Contexto: contexto })
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
}

function useUserSettings() {
  const context = React.useContext(UserSettingsContext);

  if (!context) {
    throw new Error(`useUserSettingsContext debe ser usado dentro de useUserSettingsProvider`);
  }

  return context;
}

export { UserSettingsProvider, useUserSettings };